import { ProcessStepFromQuoteRequestLine } from "#modules/similarPart/view/clustering/CompareCard";
import { Icon } from "#shared/icons/Icon";
import { ActionIcon } from "#shared/view/components/ActionIcon";

export const ProcessStepActionIcon = ({
  processStep,
  isExcluded,
  excludeProcessStep,
  includeProcessStep,
}: {
  processStep: ProcessStepFromQuoteRequestLine;
  isExcluded: boolean;
  excludeProcessStep: (processStep: ProcessStepFromQuoteRequestLine) => void;
  includeProcessStep: (processStep: ProcessStepFromQuoteRequestLine) => void;
}) => {
  if (isExcluded) {
    return (
      <ActionIcon size={14} color="gray" onClick={() => includeProcessStep(processStep)}>
        <Icon name="plus" size={14} />
      </ActionIcon>
    );
  }

  return (
    <ActionIcon size={14} color="gray" onClick={() => excludeProcessStep(processStep)}>
      <Icon name="trash" size={14} />
    </ActionIcon>
  );
};
